import { PublicAccount } from '@modules-deprecated/app/accounts/types'

export const getDisplayTitle = (account: PublicAccount) =>
  `${account.number ? account.number + ' - ' : ''} ${account.name}`
